import "./App.css";
import { GridScan } from "./components/GridScan";
import PillNav from "./components/PillNav";
import { Link, Routes, Route } from 'react-router-dom';
import p_pic from "./profile.png";
import logo from "./logo.png";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import { Analytics } from '@vercel/analytics/react';

function Home() {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        background: 'linear-gradient(to bottom, #1E1B3A, #4B4A7E, #6B8DBD)',
      }}
    >
      <GridScan
        sensitivity={0.53}
        lineThickness={0.5}
        lineColor="#4DA3FF"
        gridScale={0.3}
        scanColor="#4DA3FF"
        scanOpacity={0.6}
        enablePostProcessing={true}
        bloomIntensity={0.5}
        chromaticAberration={0.001}
        noiseIntensity={0.02}
      />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          color: "var(--text-main)",
          zIndex: 1,
        }}
      >
        <h1 style={{ fontSize: "3rem", margin: "0", fontWeight: "bold" }}>Hazim Malik</h1>
        <h2 style={{ fontSize: "1.5rem", margin: "10px 0 20px 0", color: "var(--text-muted)" }}>
          Machine Learning Engineer focused on real-world AI
        </h2>

        {/* Added button group: View Projects + Download Resume */}
        <div style={{ display: "flex", gap: "1.2rem", justifyContent: "center", margin: "1.5rem 0" }}>
          <Link to="/projects">
            <button
              style={{
                backgroundColor: "var(--accent)",
                color: "#FFFFFF",
                padding: "12px 28px",
                border: "none",
                borderRadius: "12px",
                fontSize: "1.1rem",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              View Projects
            </button>
          </Link>

          <a
            href="/Hazim_Malik_Resume.pdf"
            download="Hazim_Malik_Resume.pdf"
            style={{
              textDecoration: "none"
            }}
          >
            <button
              style={{
                backgroundColor: "transparent",
                color: "var(--accent)",
                padding: "12px 28px",
                border: "1px solid var(--accent)",
                borderRadius: "12px",
                fontSize: "1.1rem",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Download Resume
            </button>
          </a>
        </div>
      </div>

      {/* Mini Profile Card */}
      <div
        style={{
            width: "250px",
          position: "absolute",
          bottom: "20px",
          right: "20px",
          background: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(8px)",
          border: "1px solid var(--card-border)",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "16px",
          color: "var(--text-main)",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
        className="mini-profile"
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <img
            src={p_pic}
            alt="Hazim Malik"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <div>
            <h3 style={{ margin: "0", fontSize: "1.1rem" }}>Hazim Malik</h3>
            <p style={{ margin: "0", fontSize: "0.9rem", color: "var(--text-muted)" }}>ML Engineer</p>
          </div>
        </div>
        <Link to="/contact">
          <button
            style={{
              backgroundColor: "var(--accent)",
              color: "#FFFFFF",
              padding: "8px 16px",
              border: "none",
              borderRadius: "12px",
              fontSize: "0.9rem",
              cursor: "pointer",
              width: "100%",
            }}
          >
            Contact Me →
          </button>
        </Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <PillNav
        logo={logo}
        items={[
          { label: 'Home', href: '/' },
          { label: 'About', href: '/about' },
          { label: 'Projects', href: '/projects' },
          { label: 'Contact', href: '/contact' }
        ]}
        activeHref={window.location.pathname}
        baseColor="var(--bg-primary)"
        pillColor="transparent"
        pillTextColor="var(--text-main)"
        hoveredPillTextColor="var(--bg-primary)"
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Analytics />
    </div>
  );
}

export default App;